import { icons } from "assets/AssetHelper";
import dayjs from "dayjs";
import { Box } from "@mui/material";
import DriverDetailsImages from "components/Molecules/users/drivers/driverDetailsImages";
import CustomerProfileInfo from "components/Molecules/users/customers/customerProfileInfo";

export const detailsData = ({
  data,
  city,
  country,
  displayDriverDataWithImg,
  t,
}) => [
  {
    head: t("details.driver_image"),
    icon: icons?.media,
    details: [
      {
        name: displayDriverDataWithImg ? (
          <CustomerProfileInfo data={data} justifyContent={"start"} />
        ) : (
          <Box
            component="img"
            src={data?.avatar}
            width="228px"
            height="229px"
            borderRadius="6px"
          />
        ),
        width: "100%",
      },
    ],
  },
  {
    head: t("details.driver_information"),
    icon: icons?.details,
    details: [
      {
        label: t("details.name"),
        name: data?.name,
      },
      {
        label: t("details.phone"),
        name: `+${data?.country_code}${data?.phone_number}`,
      },
      {
        label: t("details.email"),
        name: data?.email,
      },
      {
        label: t("details.birthdate"),
        name: dayjs(data?.birthdate).format("DD / MM / YYYY "),
      },
      {
        label: t("details.gender"),
        name: data?.gender,
      },
      {
        label: t("details.national_id"),
        name: data?.national_id,
      },
      {
        label: t("details.country"),
        name: country && country[0]?.name,
      },
      {
        label: t("details.city"),
        name: city && city[0]?.name,
      },
      {
        label: t("details.license_info"),
        name:
          data?.driver_type === "freelancer"
            ? t("details.freelancer_driver")
            : t("details.employee_driver"),
      },
    ],
  },
  {
    head: t("details.photos"),
    icon: icons?.media,
    details: [
      {
        label: t("details.national_id_front"),
        name: (
          <DriverDetailsImages
            src={data?.national_id_media && data?.national_id_media[0]?.url}
          />
        ),
      },
      {
        label: t("details.national_id_back"),
        name: (
          <DriverDetailsImages
            src={data?.national_id_media && data?.national_id_media[1]?.url}
          />
        ),
      },
      {
        label: t("details.criminal_status_front"),
        name: (
          <DriverDetailsImages
            src={
              data?.criminal_status_media && data?.criminal_status_media[0]?.url
            }
          />
        ),
      },
      {
        label: t("details.criminal_status_back"),
        name: (
          <DriverDetailsImages
            src={
              data?.criminal_status_media && data?.criminal_status_media[1]?.url
            }
          />
        ),
      },
      {
        label: t("details.driver_license_front"),
        name: (
          <DriverDetailsImages
            src={
              data?.driver_licence_media && data?.driver_licence_media[0]?.url
            }
          />
        ),
      },
      {
        label: t("details.driver_license_back"),
        name: (
          <DriverDetailsImages
            src={
              data?.driver_licence_media && data?.driver_licence_media[1]?.url
            }
          />
        ),
      },
      {
        label: t("details.vehicle_license_front"),
        name: (
          <DriverDetailsImages
            src={
              data?.vehicle_licence_media && data?.vehicle_licence_media[0]?.url
            }
          />
        ),
      },
      {
        label: t("details.vehicle_license_back"),
        name: (
          <DriverDetailsImages
            src={
              data?.vehicle_licence_media && data?.vehicle_licence_media[1]?.url
            }
          />
        ),
      },
    ],
  },
  {
    head: t("details.dates"),
    icon: icons?.dates,
    details: [
      {
        label: t("details.created_at"),
        name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("details.updated_at"),
        name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("details.last_sign_in_at"),
        name: dayjs(data?.last_sign_in_at).format("DD-MM-YYYY HH:MM a"),
      },
    ],
  },
];
